import { useSelector } from "react-redux";

/* Whether the current merchant view may use Scan Data: merchant or
   super-merchant only, and the merchant must be registered (isScanData).

   No API call here. Sources, in order:
   - the merchant list the Super Admin (getAllMerchantList) or Agent
     (web/assignedMerchants) already loaded into Redux — covers
     "logged in as merchant";
   - userData.isScanData from the login response — covers a direct merchant
     login, if the backend includes it.
   A merchant registered moments ago shows up once the Merchant list is
   reloaded, because Register updates that page's rows but not Redux. */
const useScanDataAccess = () => {
  const role = useSelector((store) => store?.userReducer?.userRole);
  const userData = useSelector((store) => store?.userReducer?.userData);
  const merchantList = useSelector(
    (store) => store?.merchantReducer?.merchantData,
  );

  const isMerchantView = ["merchant", "super-merchant"].includes(role);
  const listRow = Array.isArray(merchantList)
    ? merchantList.find((item) => item?._id && item._id === userData?._id)
    : null;
  const isRegistered =
    listRow?.isScanData === true || userData?.isScanData === true;

  return {
    isMerchantView,
    isRegistered,
    canUseScanData: isMerchantView && isRegistered,
  };
};

export default useScanDataAccess;
